import { type Enum } from '@webapp/utils'

export const SpendingCardFundStatuses = {
  OPEN: 0,
  CLOSED: 1,
} as const
export type SpendingCardFundStatus = Enum<typeof SpendingCardFundStatuses>
